import { Component, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { Router } from '@angular/router';
import { CoreConfigService } from '@core/services/config.service';
import { LoginService } from 'app/services/auth/login.service';

@Component({
  selector: 'app-verif-email',
  templateUrl: './verif-email.component.html',
  styleUrls: ['./verif-email.component.scss']
})
export class VerifEmailComponent implements  OnInit {
  displayPassword="password";
  public coreConfig: any;
  public loginForm: UntypedFormGroup;
  public loading = false;
  public submitted = false;
  public returnUrl: string;
  public error = '';
  data:any={ 
    token:"",
    
  }
  dataError:any={
          token:"",
       
  }
  countdown: number = 60;
interval: any;
canResend: boolean = false;
  validate=false;
  public passwordTextType: boolean;
errorMessage:any="";
  // Private
  private _unsubscribeAll: Subject<any>;

  /**
   * Constructor
   *
   * @param {CoreConfigService} _coreConfigService
   */
  constructor(
    private loginService:LoginService,
    private _coreConfigService: CoreConfigService,
    private _formBuilder: UntypedFormBuilder,
    private _route: ActivatedRoute,
    private _router: Router
  ) {
    this._unsubscribeAll = new Subject();

    // Configure the layout
    this._coreConfigService.config = {
      layout: {
        navbar: {
          hidden: true
        },
        menu: {
          hidden: true
        },
        footer: {
          hidden: true
        },
        customizer: false,
        enableLocalStorage: false
      }
    };
  }

 

 
  tokenVerif()
  {
    this.dataError.token="";
    this.loading=true;
    let user = localStorage.getItem('currentUser');
    let users = JSON.parse(user);
    let dataSend={
      'token':this.data.token,
      'email':users.email
    }
    if(this.data.token.length>0 && this.data.token.length<10)
    {
       this.loginService.veriftoken(dataSend)
          .subscribe(
            data => {
              console.log(data)
              if(data.message && data.message==1)
              {
                 this.dataError.token="Code incorrecte";
              }else 
              {
                 this.dataError.token="";
                 users.is_active=true;
                 localStorage.setItem('currentUser',JSON.stringify(users));
                  this._router.navigate(["/main/parametre/entreprise"]);
              }
              
            },
            error => {
           

            }
          );
          this.loading=false;
    }else 
    {
      this.dataError.token="Code incorrecte";
      this.loading=false;
    }

        
        
  }

  
  ngOnInit(): void {
    this.loginForm = this._formBuilder.group({
      email: ['', [Validators.required, Validators.email]],
      password: ['', Validators.required]
    });
    this.returnUrl = this._route.snapshot.queryParams['returnUrl'] || '/';
    this._coreConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe(config => {
      this.coreConfig = config;
    });
     this.startCountdown();
  }
  startCountdown() {
  this.canResend = false;
  this.countdown = 60;

  this.interval = setInterval(() => {
    this.countdown--;
    if (this.countdown <= 0) {
      clearInterval(this.interval);
      this.canResend = true;
    }
  }, 10);
}
resendCode() {
  let user = localStorage.getItem('currentUser');
  let users = JSON.parse(user);
  if (!this.canResend) return;
   this.loginService.verifemail(users)
          .subscribe(
            data => {
              
            
         
            },
            error => {
           

            }
          );

  this.startCountdown();
}



}
